import React from 'react'

import { Container } from '@sainsburys-tech/fable'

import PublicDSIBHeader from '../PublicDSIBHeader'

import '../../sass/components/password-changed-success.scss'

const loginRedirect = () => {
  window.location.href = `${window.location.origin}/login`
}

const PasswordChangedSuccess = () => (
  <Container as="div" className="dsib-passwordChanged">
    <PublicDSIBHeader />

    <main className="dsib-passwordChanged__content">
      <div className="dsib-passwordChanged__panel">
        <h2 className="dsib-passwordChanged__title">Your password has been changed</h2>
        <p className="dsib-passwordChanged__text">
          Please open the Digital sign-in book app and log in with this new password.
        </p>
        <p className="dsib-passwordChanged__text">
          Click
          {' '}
          <button type="button" className="dsib-passwordChanged__link" onClick={loginRedirect}>
            here
          </button>
          {' '}
          to access the Log in page
        </p>
      </div>
    </main>
  </Container>
)

export default PasswordChangedSuccess
